import { createContext } from 'react';
import type { ToastContextType } from '@/types/components/common/toast';

export const ToastContext = createContext<ToastContextType | undefined>(undefined);